import React from 'react';
import {AboutYouLogo} from '../../../features/AboutYouLogo/AboutYouLogo';
import {useTrackHeaderOriginClick} from '../hooks/useOriginClickTrackingFunction';

interface HeaderAboutYouLogoWrapperProps {
  className?: string;
}
export const HeaderAboutYouLogoWrapper: React.FC<
  HeaderAboutYouLogoWrapperProps
> = ({className}) => {
  const trackOriginClick = useTrackHeaderOriginClick();

  return (
    <AboutYouLogo
      className={className}
      disableSvgLogo
      disableLoggedInUserUpdates={false}
      trackOriginClickFunction={trackOriginClick}
    />
  );
};
